import { Routes } from "@angular/router";
import { MainPageComponent } from "./core/layout/main-page/main-page.component";
import { LoginComponent } from "./core/authentication/login/login.component";
import { authGuard } from "./core/guards/auth.guard";
import { unAuthGuard } from "./core/guards/un-auth.guard";

export const APP_ROUTES = {
  ROOT: '',
  AUTH_LOGIN: 'auth/login',
  REGISTRATION_CARD: 'registration/card',
  PHOTO_RECORDING: 'registration/photo-recording',
  VGK: 'registration/vgk',
  IDK_INSPECTION: 'registration/idk-inspection',
  RPM_EVENT: 'registration/rpm-event',
  TRANSIT_DECLARATION: 'transit/declaration',
  PRELIMINARY_INFORMATION_PI_REQUEST: 'preliminary-information/pi-request',
  PRELIMINARY_INFORMATION_PRE_INFO: 'preliminary-information/pre-info',
  TEMPORARY_IMPORT_EXPORT_CITD: 'temporary-import-export/citd',
  TEMPORARY_IMPORT_EXPORT_TSLP: 'temporary-import-export/tslp',
  CUSTOMS_CONTROL_ACT: 'customs-control/act',
  CUSTOMS_CONTROL_EVENT_LOG: 'customs-control/event-log',
};

export const routes: Routes = [
  {
    path: APP_ROUTES.ROOT,
    component: MainPageComponent,
    canActivate: [authGuard],
    children: [
      {
        path: APP_ROUTES.TRANSIT_DECLARATION,
        loadChildren: () => import("./modules/transit-control-system/transit-control-system.routes").then((m) => m.TRANSIT_DECLARATION_ROUTES),
      },
      {
        path: APP_ROUTES.REGISTRATION_CARD,
        loadChildren: () => import("./modules/registration/registration-card/cards.routes").then((m) => m.CARDS_ROUTES),
      },
      {
        path: APP_ROUTES.PHOTO_RECORDING,
        loadChildren: () => import("./modules/registration/photo-recording/photo-recording.routes").then((m) => m.PHOTO_RECORDING_ROUTES),
      },
      {
        path: APP_ROUTES.VGK,
        loadChildren: () => import("./modules/registration/vgk/vgk.routes").then((m) => m.VGK_ROUTES),
      },
      {
        path: APP_ROUTES.IDK_INSPECTION,
        loadChildren: () => import("./modules/registration/idk-inspection/idk-inspection.routes").then((m) => m.IDK_INSPECTION_ROUTES),
      },
      {
        path: APP_ROUTES.RPM_EVENT,
        loadChildren: () => import("./modules/registration/rpm-event/rpm-event.routes").then((m) => m.RPM_EVENT_ROUTES),
      },
      {
        path: APP_ROUTES.PRELIMINARY_INFORMATION_PI_REQUEST,
        loadChildren: () => import("./modules/preliminary-information/preliminary-information.routes").then((m) => m.PI_REQUEST_ROUTES),
      },
      {
        path: APP_ROUTES.PRELIMINARY_INFORMATION_PRE_INFO,
        loadChildren: () => import("./modules/preliminary-information/preliminary-information.routes").then((m) => m.PRE_INFO_ROUTES),
      },
      {
        path: APP_ROUTES.TEMPORARY_IMPORT_EXPORT_CITD,
        loadChildren: () => import("./modules/temporary-import-export/temporary-import-export.routes").then((m) => m.CITD_ROUTES),
      },
      {
        path: APP_ROUTES.TEMPORARY_IMPORT_EXPORT_TSLP,
        loadChildren: () => import("./modules/temporary-import-export/temporary-import-export.routes").then((m) => m.TSLP_ROUTES),
      },
      {
        path: APP_ROUTES.CUSTOMS_CONTROL_ACT,
        loadChildren: () => import("./modules/customs-control/customs-control.routes").then((m) => m.ACT_CUSTOMS_ROUTES),
      },
      {
        path: APP_ROUTES.CUSTOMS_CONTROL_EVENT_LOG,
        loadChildren: () => import("./modules/customs-control/customs-control.routes").then((m) => m.EVENT_LOG_ROUTES),
      }
    ],
  },
  {
    path: APP_ROUTES.AUTH_LOGIN,
    component: LoginComponent,
    canActivate: [unAuthGuard],
  },
];
